import Vue from 'vue';
import router from './router';
import ElementUI from 'element-ui';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import 'element-ui/lib/theme-chalk/index.css';
import '@fortawesome/fontawesome-free/css/all.css';
import App from './App.vue';

Vue.use(ElementUI, { locale: zhLocale });
// 如果 router 是插件，Vue.use(router) 在 Vue 2 中不需要，因为 router 通常作为选项传入
// 但若 router 本身就是 VueRouter 实例，Vue.use(VueRouter) 已经在 router 文件中执行了

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
